import React, { useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';


import { useNavigate } from 'react-router-dom';

const SessionInterceptor: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { logout, isAuthenticated } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const interceptor = axios.interceptors.response.use(
            (response) => response,
            (error) => {
                // Only treat a 401 as "your session timed out" when the frontend
                // believed the user was actually logged in. Plenty of 401s are
                // ordinary auth failures, not an expired session - a wrong
                // password on the login page, or a logged-out visitor trying to
                // like/reply to a comment - and force-logging out + redirecting
                // to /login for those yanks people off whatever page they were
                // on for no reason. isAuthenticated is only true after a real
                // login, so this now only fires for a genuinely revoked/expired
                // session.
                if (error.response && error.response.status === 401 && isAuthenticated) {
                    const url = error.config?.url;
                    console.log(`Session expired or revoked at ${url}. Logging out...`);
                    logout();
                    navigate('/login');
                }
                return Promise.reject(error);
            }
        );

        return () => {
            axios.interceptors.response.eject(interceptor);
        };
    }, [logout, navigate, isAuthenticated]);

    return <>{children}</>;
};

export default SessionInterceptor;
